/** Measures the shared desktop dome across the three homepage sections. */
(function () {
  var SELECTOR_TREES = '[id^="shopify-section-"][id$="__product_list_trees"]';
  var SELECTOR_LEARNMORE = '[id^="shopify-section-"][id$="__media_with_content_learnmore"]';
  var SELECTOR_CITRUS = '[id^="shopify-section-"][id$="__section_citrus_in_life"]';

  function measure() {
    var trees = document.querySelector(SELECTOR_TREES);
    var learnmore = document.querySelector(SELECTOR_LEARNMORE);
    var citrus = document.querySelector(SELECTOR_CITRUS);
    if (!trees || !learnmore || !citrus) return;

    var treesRect = trees.getBoundingClientRect();
    var learnmoreRect = learnmore.getBoundingClientRect();
    var citrusRect = citrus.getBoundingClientRect();
    var treesHeight = treesRect.height;
    var total = citrusRect.bottom - treesRect.top;

    trees.style.setProperty('--vc-dome-total-height', total + 'px');
    trees.style.setProperty('--vc-dome-fct-height', treesHeight + 'px');
    // Mobile uses separate paints; this variable sizes the first (trees + learn-more) paint.
    // Measure anchor-to-anchor so margins between sections are included.
    trees.style.setProperty('--vc-dome-fct-gci-height', (learnmoreRect.bottom - treesRect.top) + 'px');
  }

  function debounce(fn, wait) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, wait);
    };
  }

  var debouncedMeasure = debounce(measure, 150);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', measure);
  } else {
    measure();
  }
  // Fonts/images can change heights after DOMContentLoaded; resize also changes breakpoints.
  window.addEventListener('load', measure);
  window.addEventListener('resize', debouncedMeasure);
})();
